import httpClient from '@/lib/httpClient.js'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function useCreateTransfer() {
  const queryClient = useQueryClient()

  const action = async ({
    date,
    vaultId,
    vaultToId,
    description = '',
    amount,
    recurring_settings,
    modelId,
  }) => {
    const response = await httpClient.post(`team/cash-flow/transfers`, {
      transaction_date: date,
      vault_from: vaultId,
      vault_to: vaultToId,
      description,
      amount,
      recurring_settings,
      what_if_id: modelId,
    })
    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onError: (e) => {
      toast.error(e?.response?.data?.message ?? 'An error occurred.')
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['transactions'] })
      queryClient.invalidateQueries({ queryKey: ['vaults'] })
      queryClient.invalidateQueries({
        queryKey: ['transaction-repeat-options'],
      })
      queryClient.invalidateQueries({ queryKey: ['todo-count'] })
      queryClient.invalidateQueries({ queryKey: ['todos', 'list'] })

      toast.success('Transfer successfully added.')
    },
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
}
